import { render } from "./SchoolsEdit.vue?vue&type=template&id=db24c410"
import script from "./SchoolsEdit.vue?vue&type=script&lang=js"
export * from "./SchoolsEdit.vue?vue&type=script&lang=js"

import "./SchoolsEdit.vue?vue&type=style&index=0&id=db24c410&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__